"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePhone = exports.validatePassword = exports.validateNationalId = exports.validateEmail = exports.validateCreditCardNumber = exports.validateCreditCardDate = exports.validateCreditCardCode = exports.REGEX = exports.EXAMPLES = void 0;
var EXAMPLES = {
  EMAIL: 'mail@example.com',
  NATIONALID: {
    SE: '19001122-1234',
    NO: '11028559912'
  },
  PHONE: {
    SE: '+46 07 123 456 78',
    NO: '+47 815 12 345'
  },
  ZIPCODE: {
    SE: '111 99',
    NO: '0025'
  }
};
exports.EXAMPLES = EXAMPLES;
var REGEX = {
  EMAIL: "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$",
  PASSWORD: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,15}$',
  NATIONALID: {
    SE: '^(19|20)?(\\d{6}([-+]|\\s)\\d{4}|(?!19|20)\\d{10})$',
    FI: '^[0-9]{6}[\\-|A]?(?:[0-9]+){1,3}[0-9A-Za-z]$',
    NO: '(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])\\d{2}( |-)?\\d{5}'
  },
  PHONE: {
    SE: /^(\+46|0046|0)(\s?[0]?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9])$/,
    NO: /^(\+47|0047|0)(\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9])$/
  },
  CARD: {
    NUMBER: '^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\\d{3})\\d{11})$',
    DATE: '^(0[1-9]|1[0-2])/([0-9]{2})$',
    CODE: '^[0-9]{3,4}$'
  },
  ZIPCODE: {
    SE: /^\d{3}\s?\d{2}$/,
    NO: /^\d{4}$/
  },
  ALPHANUMERIC: /^[A-Za-z0-9-]*$/,
  ALPHANUMERIC_UNDERSCORE: /^[A-Za-z0-9_]*$/
};
exports.REGEX = REGEX;

var validate = function validate(value, regex) {
  return RegExp(regex).test(value);
}; // TODO: Add error checks in these functions to avoid wrong param error


var validateNationalId = function validateNationalId(id, country) {
  return validate(id, REGEX.SSN[country.toUpperCase()]);
};

exports.validateNationalId = validateNationalId;

var validateEmail = function validateEmail(email) {
  return validate(email, REGEX.EMAIL);
};

exports.validateEmail = validateEmail;

var validatePassword = function validatePassword(password) {
  return validate(password, REGEX.PASSWORD);
};

exports.validatePassword = validatePassword;

var validatePhone = function validatePhone(phone, countries) {
  var _countries = Array.isArray(countries) ? countries : [countries];

  return _countries.reduce(function (res, country) {
    return res && validate(phone, REGEX.PHONE[country.toUpperCase()]);
  }, true);
};

exports.validatePhone = validatePhone;

var validateCreditCardNumber = function validateCreditCardNumber(card) {
  return validate(card, REGEX.CARD.NUMBER);
};

exports.validateCreditCardNumber = validateCreditCardNumber;

var validateCreditCardDate = function validateCreditCardDate(date) {
  return validate(date, REGEX.CARD.DATE);
};

exports.validateCreditCardDate = validateCreditCardDate;

var validateCreditCardCode = function validateCreditCardCode(code) {
  return validate(code, REGEX.CARD.CODE);
};

exports.validateCreditCardCode = validateCreditCardCode;